import Vue from 'vue';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'vue-resize/dist/vue-resize.css';
import 'mdbvue/build/css/mdb.css';
import VueAnalytics from 'vue-analytics';
import VueResize from 'vue-resize';
import App from './App.vue';

Vue.use(VueAnalytics, {
  id: 'UA-49447166-2',
});
Vue.use(VueResize);
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
